module.exports = __webpack_public_path__ + "static/image-03-b@2x-8900cdede538b1f067bb46bbe64c0c93.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/case-studies/zinc/image-03-b@2x.png
// module id = 439
// module chunks = 3627797113349 20562973939449 33019919093843